import { render, staticRenderFns } from "./new-issue.vue?vue&type=template&id=d217aeb4"
import script from "./new-issue.vue?vue&type=script&lang=js"
export * from "./new-issue.vue?vue&type=script&lang=js"
import style0 from "./new-issue.vue?vue&type=style&index=0&id=d217aeb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports